// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1eYC4","checkboxCol":"Table_checkboxCol__1fsqF","emailCol":"Table_emailCol__Wykqn","actionCol":"Table_actionCol__pfWWo"};